import { memo } from "react";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";

const PopupConfirm = ({ open, title, onClose, onAccept }) => {
  const { t: getLabel } = useTranslation();

  const onHandleAccept = () => {
    onClose();
    onAccept();
  };

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show" />
      <div className="modal modal-blur fade show" style={{ display: "block" }} tabIndex="-1">
        <div className="modal-dialog modal-sm modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body" style={{ fontSize: 18, paddingTop: 30 }}>
              {title}
            </div>
            <div className="modal-footer">
              <button className="btn" style={{ width: 100 }} onClick={onClose}>
                {getLabel(LangConstant.L_CANCEL_BUTTON)}
              </button>
              <button className="btn btn-primary" style={{ width: 100 }} onClick={onHandleAccept}>
                {getLabel(LangConstant.L_AGREE)}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(PopupConfirm);
